import { VegType } from "@swiggy-private/dls-web-recipe-common-web/dist/components/ItemListWidget/types";
import { OBJECT_VALUES } from "../../../constants/analytics";

export const CROSS_SELL_BACKGROUND = "background_Secondary";
export const CROSS_SELL_TOP_HANDLE_OFFSET = 8;
export const CROSS_SELL_ANIMATION_DURATION_MS = 300;

export const CROSS_SELL_GRID_WIDGET_META = {
    showArrow: false,
} as const;

export const VEG_PREFERENCE = "VEG";
export const NONVEG_PREFERENCE = "NONVEG";

// to check with BE if these will remain same for all restaurants and they can't change it without informing us
export const VEG_FACET_QUERY_ID = "isVegfacetquery0";
export const NONVEG_FACET_QUERY_ID = "isVegfacetquery1";

export const CROSS_SELL_CONSTRAINT_DEFAULTS = {
    MIN_ITEMS: 1,
    MAX_ITEMS: 3,
} as const;

export const CROSS_SELL_DISH_CARD_FIELD_DEFAULTS = {
    DEFAULT_IS_VEG: 0,
    DEFAULT_VEG_TYPE: 0,
    DEFAULT_IS_BESTSELLER: false,
    DEFAULT_VEG_CLASSIFIER: VegType.NON_VEG,
    EMPTY_AGGREGATED_RATING: {
        RATING: "0",
        RATING_COUNT: "0",
        RATING_COUNT_V2: "0",
    },
} as const;

export const CROSS_SELL_HEADER_DEFAULTS = {
    FALLBACK_TITLE: "You might also like",
    FALLBACK_SUBTITLE: "Popular add-ons with this dish",
    HEADER_IMAGE_ID: "portal/static-assets/icons/digital-menu/cross-sell-header-image-2.png",
    HEADER_STYLING: { padding: { top: 12, bottom: 12, left: 16, right: 16 } },
    HEADER_IMAGE_SIZE: "36px",
} as const;

export const CROSS_SELL_GRID_TYPOGRAPHY = {
    titleTextVariant: "V2.body1.neutral.medium",
    subtitleTextVariant: "V2.overline.neutral.medium",
    titleColor: "text_Highest_Emphasis",
    subtitleColor: "text_Med_Emphasis",
    spaceBetweenTitleAndSubtitle: "empty",
} as const;

export const CROSS_SELL_CAROUSEL_CONFIG = {
    showScrollIndicator: true,
    scrollTime: 2000,
    disableAutoscroll: true,
    disableEntranceAnimation: true,
    scrollIndicatorConfig: {
        padding: { bottom: 12, top: 12 },
        pillBackgroundColor: "text_High_Emphasis",
        pillTextColor: "text_inverse_Highest_Emphasis",
        background: CROSS_SELL_BACKGROUND,
    },
} as const;

export const CROSS_SELL_ANALYTICS_SECTION = "cross-sell";

export const CROSS_SELL_MENU_DEFAULT_PARENT_TYPE = "Food";

export const CROSS_SELL_CUSTOMIZABLE_TRUE = "true";
export const CROSS_SELL_CUSTOMIZABLE_FALSE = "false";

export const CROSS_SELL_WIDGET_IMPRESSION = {
    ACTION: "add-item",
    LABEL: OBJECT_VALUES.ADD_ITEM,
    OBJECT_POSITION: 9999,
    SOURCE: "Widget Block",
} as const;
